<template lang="pug">
  div(v-if="!userChangePassword && !userInfoToMigrate")
    h2 Dados para acesso

    form.form-group(onsubmit="return false" name="formLogin", novalidate="")
      .missing-payment(v-if="missingPayment")
        p O período de utilização do sistema expirou.
        p
          | Para saber como prosseguir, entre em contato com &nbsp;
          a(href="mailto:faturamento@pontotel.com.br") faturamento@pontotel.com.br

      template(v-if="step === 'email'")
        PTextField(v-model.trim="email" v-focus @keyup.enter.once="toStep('password')" name="email"
          required label="email" key="emailstep" type="email" autocomplete="username" id="email")

        PButton(:loading="loadingStep" @click="toStep('password')" color="info" size="md" block) Próximo

      template(v-else="")
        .step-password
          PTextField(v-model="email" name="email" required label="email" readonly key="passstep")

          div(style="margin-bottom: 13px")
            PButton(:loading="loadingStep" @click="toStep('email')" color="info" size="md")
              | < voltar

        PTextField(v-model="password" v-focus, @keydown.enter.prevent="applyLogin" name="password"
          required label="senha" type="password" autocomplete="current-password")

        PButton(@click="applyLogin", :disabled="loadingApplyLogin" :loading="loadingApplyLogin"
          color="info" size="md" block) Entrar

      a.to-click(@click="showForgetPassword" style="margin-top: 20px; display: block") Esqueci minha senha

    UseTermsModal(@acceptedTerms="goToMainScreen")

    hr

    div
      strong.mb15 Ainda não é nosso cliente?
    br
    div.text-center
      PButton(color="warning" size="md" block @click="goToLandingPage") Conheça nosso site

  div(v-else="")
    ChangePassword(v-if="!userInfoToMigrate", :user="userChangePassword", @passwordChanged="passwordChanged")

    Migration(v-else="", :mp="mp", :userInfoToMigrate="userInfoToMigrate",
      @successMigration="clearInfo", :password="password")

</template>

<script>
import { executeAuthCognitoRequest, configureCongito } from 'src/components/Cognito'
import ChangePassword from './ChangePassword'
import Migration from './Migration'
import UseTermsModal from './UseTermsModal'
import Auth from '@aws-amplify/auth'

async function retryAmplifyLogin (email, password, maxRetries = 3) {
  // Back can cry some times with so many requests.
  // Use this function to retry 3 times a request.
  // Usage: retryRequest(API.timesheet.post, {load: 'lines'}, {})

  return new Promise(async function (resolve, reject) {
    let triesCounter = 0
    let lastError

    while (triesCounter < maxRetries) {
      triesCounter = triesCounter + 1
      try {
        const result = await Auth.signIn(email, password)
        resolve(result)
        return
      } catch (err) {
        if (err.code !== 'TooManyRequestsException') {
          reject(err)
        }
        lastError = err
      }
    }
    reject(lastError)
  })
}

export default {
  data () {
    return {
      mp: 'F2Mdke4sdj7vuzuA&vCkP+V*A',
      email: '',
      password: '',
      step: 'email',
      userChangePassword: null,
      userPoolId: null,
      userPoolWebClientId: null,
      userInfoToMigrate: false,
      loadingStep: false,
      loadingApplyLogin: false,
      missingPayment: false
    }
  },
  methods: {
    async applyCognitoLogin (password = null) {
      password = password === null ? this.password : password

      const { userPoolWebClientId, userPoolId, useCognito } = await executeAuthCognitoRequest(this.email)
      let user = null

      if (useCognito) {
        configureCongito({userPoolId, userPoolWebClientId})

        user = await retryAmplifyLogin(this.email, password)
      }

      return {user, userPoolId, userPoolWebClientId, useCognito}
    },
    async applyLogin () {
      try {
        this.loadingApplyLogin = true
        const {user, userPoolId, userPoolWebClientId, useCognito} = await this.applyCognitoLogin()

        if (!useCognito) {
          // this compman was not migrated or is migrated but we dit not enabled it (comp_man.use_cognito) yet
          await this.legacyLoginCompManNotInCognito()
          this.loadingApplyLogin = false
          return
        }

        if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
          this.error = 'Você precisa atualizar a sua senha'
          this.type = 'changePassword'
          this.userChangePassword = user
        } else {
          console.log('calling cognito login')
          console.log(user)
          console.log(userPoolId)
          console.log(userPoolWebClientId)
          await this.onSuccessfullLogin(
            null, user.signInUserSession.idToken.jwtToken, userPoolId, userPoolWebClientId
          )
        }
      } catch (e) {
        console.log(e)

        if ((e.code === 'NotAuthorizedException' && e.message === 'Password attempts exceeded') ||
          e.code === 'TooManyRequestsException') {
          this.clearInfo()
          this.$swal({
            type: 'info',
            title: 'Número de tentativa excedido',
            text: 'Tente novamente em alguns minutos'
          })
          this.loadingApplyLogin = false
          return
        } else if (e.code === 'UserNotFoundException' || e.status === 400) {
          // probably that this comp_man has not beign migrated yet
          // this.$swal({
          //   title: 'not migrated'
          // })
          await this.legacyLoginCompManNotInCognito()
          this.loadingApplyLogin = false
          return
        } if (e.message === 'Incorrect username or password.' && e.code === 'NotAuthorizedException') {
          // Two chances here: user already changed cognito password after migration
          // and it wrote the wrong password or it has not changed password yet

          // Two checks here: user successfuly authenticated awith legacy login and if the cognito loggin
          // succesfully works with the migration password

          try {
            await this.legacyLoginRequest()
            // if gets here user had successfuly sign in legacy login, lets try user migration password now
            // only in production or homolog that we will migrate user
            if (
              window.location.origin.includes('new-front.pontotel.com.br') ||
              window.location.origin.includes('atento.pontotel.com.br') ||
              window.location.origin.includes('beta.pontotel.com.br') ||
              window.location.origin.includes('app.pontotel.com.br') ||
              window.location.origin.includes('homolog.pontotel.com.br') ||
              window.location.origin.includes('hml.pontotel.com.br') ||
              window.location.origin.includes('prod.pontotel.com.br') ||
              window.location.origin.includes('canary.pontotel.com.br') ||
              window.location.origin.includes('gestao.pontotel.com.br')
            ) {
              this.userInfoToMigrate = await this.applyCognitoLogin(this.mp)
            } else {
              this.$swal({
                type: 'info',
                text: 'Operação não permitida nesse ambiente'
              })
            }
          } catch (e) {
            console.warn(e)
            this.clearInfo()
            this.loadingApplyLogin = false
            if (e.code === 'NotAuthorizedException' && e.message === 'Password attempts exceeded') {
              this.clearInfo()
              this.$swal({
                type: 'info',
                title: 'Número de tentativa excedido',
                text: 'Tente novamente em alguns minutos.'
              })
            } else {
              this.$swal({
                type: 'error',
                text: 'Usuário ou senha inválido'
              })
            }
          }
        } else {
          // wrong email
          this.$swal({
            type: 'error',
            text: 'Usuário ou senha inválido'
          })
        }
        this.loadingApplyLogin = false
      }
    },
    async legacyLoginCompManNotInCognito () {
      // try normal login without cognito
      try {
        const login = await this.legacyLoginRequest()

        this.$store.commit('cognitoTokens', {
          authorization: 'Bearer ' + login.data.access_token,
          accessToken: null
        })

        await this.$store.dispatch('getUserInfo', true)

        if (this.$store.state.userInfo.compMan.useCognito) {
          throw new Error('This user has been migrated to cognito. This code should not been executed')
        } else {
          console.log('calling legacy login')
          console.log(login.data)
          this.onSuccessfullLogin(login.data.access_token, null, null, null, false)
        }
      } catch (e) {
        if (e.body === 'Auth Failed: Payment Expired') {
          this.missingPayment = true
          return
        }

        console.log('erro in legacu login', e)
        this.clearInfo()
        this.$swal({
          type: 'error',
          text: 'Usuário ou senha inválido'
        })
      }
    },
    async legacyLoginRequest () {
      const login = await this.$API.login.save({
        username: this.email,
        password: this.password
      })
      return login
    },
    async onSuccessfullLogin (
      authorization, accessToken, userPoolId = null, userPoolWebClientId = null, getUserInfo = true
    ) {
      this.$store.commit('cognitoTokens', {
        authorization: authorization ? 'Bearer ' + authorization : null,
        accessToken: accessToken ? 'Bearer ' + accessToken : null,
        userPoolId,
        userPoolWebClientId
      })

      if (getUserInfo === true) {
        await this.$store.dispatch('getUserInfo', true)
      }
      this.$store.dispatch('common/loadMainCommons')

      this.$store.dispatch('getVisual', {forceReload: true})

      this.saveFirebaseMessagingToken(this.$store.state.userInfo.id)
      this.checkUseTerms()
    },
    clearInfo () {
      this.password = ''
      this.userChangePassword = null
      this.userPoolId = null
      this.userPoolWebClientId = null
      this.userInfoToMigrate = false
    },
    showForgetPassword () {
      this.$router.push('/cognito/forgotPassword')
    },
    passwordChanged () {
      this.userChangePassword = null
    },
    goToLandingPage () {
      document.cookie = 'ABerRedirect=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;secure'
      window.location.href = 'http://www.pontotel.com.br'
    },
    async warnUserThings () {
      const { roleGroup } = this.$store.state.userInfo

      if (roleGroup.kind === 'all' || roleGroup.kind === 'group') {
        this.$API.deviceManage.get(
          {
            type: 'pc',
            fields: JSON.stringify(
              [
                'id', 'device_type', 'fingerprint', 'companies',
                'employee', 'name', 'reason', 'active', 'personal', 'can_lock_folha', 'has_recognize_face'
              ]
            ),
            active: false
          }
        )
          .then(result => {
            if (result.success.length > 0) {
              this.$swal({
                type: 'warning',
                title: 'Atenção',
                text: 'Existem ' + result.success.length + ' dispositivos pendentes de ' +
                  'autorização. Para verificar, entre em Admin > Gerenciamento > Ver Dispositivos.'
              })
            }
          })

        this.$API.twoWayLockerNotifications.get()
          .then(response => {
            if (response.success) {
              this.$swal({
                type: 'warning',
                title: 'Atenção',
                text: response.success.text
              })
            }
          })
      }
    },
    checkUseTerms () {
      const { compMan, roleGroup, email } = this.$store.state.userInfo

      if (!compMan.acceptedTerms && !email.includes('lar21@') && roleGroup.name === 'rh') {
        this.$modal.show('useTermsModal')
      } else {
        this.goToMainScreen()
      }
    },
    goToMainScreen () {
      this.warnUserThings()
      this.$router.push('/')
    },
    toStep (type) {
      if (type !== 'email' && (!this.email.includes('@') || this.email.length < 5)) {
        return
      }
      // this.loadingStep = true
      // if (this.step === 'email' && type === 'password') {
      //   try {
      //     await executeAuthCognitoRequest(this.email)
      //   } catch (e) {
      //     console.warn('tried to check SAML URL using back, but failed')
      //     console.warn(e)
      //   }
      // }
      // this.loadingStep = false
      this.step = type
    },
    async saveFirebaseMessagingToken (userid) {
      try {
        await Notification.requestPermission().then(async (permission) => {
          if (permission === 'granted') {
            console.log('Notification permission granted.')
          } else {
            console.log('Unable to get permission to notify.')
          }
        })

        const currentToken = await window.firebaseMessaging.getToken()

        if (currentToken) {
          console.info('bora salvar o token do firebase')
          await this.$API.userFirebaseToken.save({id: userid, entity: 'user'}, {firebaseToken: currentToken})
        } else {
          console.log('No Instance ID token available. Request permission to generate one.')
        }
      } catch (e) {
        console.error('It was not possible to save firebase token')
      }
    }
  },
  components: {ChangePassword, Migration, UseTermsModal}
}
</script>

<style scoped lang="scss">
.form-control {
  font-size: 18px;
  height: 50px;
}

.form-control, .control-label {
  width: 100%;
}
.sign-in-button {
  width: 100%;
  height: 50px;
}
.missing-payment {
  width: 100%;
  height: 100%;
  background-color: #2a1f0b1a;
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 20px;
}
.step-password {
  display: grid;
  align-items: flex-end;
  grid-template-columns: 1fr 0.3fr;

}
</style>
